angular.module('app.filters').filter('label', (Config, $sce) =>
    function(input, collection) {
        if (typeof(collection) === 'string') {
            collection = Config[collection];
        }
        const selected = _.find(collection, e => e.value === input);

        // XXX: using the trustAsHtml means we need to use <span ng-bind-html="foo|label" /> instead of straight {{foo|label}}
        //if selected?.label and selected?.hint
        //  $sce.trustAsHtml("<span title=#{selected.hint}>#{selected.label}</span>")
        //else if selected?.label
        if (selected && selected.label) {
            return selected.label;
        } else if (input === 'unknown') {
            return 'Unknown';
        } else if (!input) {
            return 'Default';
        } else {
            return `Unknown: ${input}`;
        }
    }
);


// WEBPACK FOOTER //
// ./filters/label.js